import {
  POS_PRINTERS_LOADING,
  POS_PRINTERS_LIST,
  POS_PRINTERS_ERROR,
} from "./actionTypes";

const initialState = {
  loading: false,
  printers: [],
  error: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case POS_PRINTERS_LOADING:
      return { ...state, loading: true, error: null };
    case POS_PRINTERS_LIST:
      return { ...state, loading: false, printers: action.payload, error: null };
    case POS_PRINTERS_ERROR:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}
